import { Permission } from '../users/permission';

export enum ApiScopes {
  ApplicationCreate = Permission.ApplicationCreate,
  ApplicationFileCreate = Permission.ApplicationFileCreate,
  CronjobRun = Permission.CronjobRun,
  IntegrationsHealthRead = Permission.IntegrationsHealthRead,
  LeadCreate = Permission.LeadCreate,
  PlatformConfigurationRead = Permission.PlatformConfigurationRead,
  UnderwritingRequirementsCreate = Permission.UnderwritingRequirementsCreate,
}
